import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Pasamos el invierno sin nebulizador gracias al jarabe de Ambay. Ahorré 50 lucas el primer mes.',
  name: 'Mariela',
  location: 'Lanús, Bs. As.'
}, {
  quote: 'Mis valores de hígado dieron perfectos con el té de Carqueja. El médico no lo podía creer.',
  name: 'Roberto',
  location: 'Córdoba Capital'
}];
export function Testimonials() {
  return <section className="py-20 bg-parchment relative" data-id="element-223">
      <div className="max-w-5xl mx-auto px-4" data-id="element-224">
        <ScrollReveal data-id="element-225">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brown mb-8" data-id="element-226">
            Familias que ya recuperaron el control
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={100} data-id="element-227">
          <div className="mb-10" data-id="element-228">
            <img src="https://cdn.magicpatterns.com/uploads/jt2Z8hhWzaksgdQenqBMEB/20260323_1552_Image_Generation_simple_compose_01kme0k8vjf22btd8bn48xd47y.png" alt="Testimonios reales de familias que usan el Botiquín Ancestral" className="w-full max-w-3xl mx-auto rounded-2xl shadow-lg border border-brown/10" data-id="element-229" />
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-230">
          {testimonials.map((t, i) => <ScrollReveal key={i} delay={i * 200} data-id="element-231">
              <div className="bg-white p-8 rounded-2xl shadow-md border border-brown/5 relative h-full flex flex-col" data-id="element-232">
                <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-forest/10" data-id="element-233" />
                <div className="flex gap-1 mb-4" data-id="element-234">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber text-amber" data-id="element-235" />)}
                </div>
                <p className="font-sans text-lg text-brown/80 italic mb-6 flex-1" data-id="element-236">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-237">
                  <div className="w-12 h-12 bg-sage rounded-full flex items-center justify-center text-forest font-bold text-xl" data-id="element-238">
                    {t.name[0]}
                  </div>
                  <div data-id="element-239">
                    <p className="font-bold text-brown" data-id="element-240">{t.name}</p>
                    <p className="text-sm text-brown/60" data-id="element-241">{t.location}</p>
                  </div>
                </div>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}